import { getActiveFiltersFromURL, getPageFromURL } from '3-components/ListingApp/ListingFilters/ListingFilterHelpers';
import { type ActiveFilter } from '3-components/ListingApp/ListingFilters/ListingFiltersTypes';
import queryString from 'query-string';
import { useState } from 'react';
import RealEstateListingContext, {
    type RealEstateListingContextProps,
    type RealEstateListingProps,
    type RealEstateListingView,
    VIEW_MAP
} from './RealEstateListingContext';

interface RealEstateListingProviderProps extends RealEstateListingProps {
    children: React.ReactNode;
}

const RealEstateListingProvider = (props: RealEstateListingProviderProps): JSX.Element => {
    const { children, map, listing, ...realEstateListingProps } = props;

    const initialView = queryString.parse(window.location.search).view as RealEstateListingView || VIEW_MAP;

    const [activeItemId, setActiveItemId] = useState<string>('');
    const [view, setView] = useState<RealEstateListingView>(initialView);
    const [page, setPage] = useState(getPageFromURL());

    const activeFiltersInitialValue = view === VIEW_MAP ?
        getActiveFiltersFromURL(map.filters) :
        getActiveFiltersFromURL(listing.filters);

    const [activeFilters, setActiveFilters] = useState<ActiveFilter[]>(activeFiltersInitialValue);
    const [filterModalOpen, setFilterModalOpen] = useState<boolean>(false);

    const providerValue: RealEstateListingContextProps = {
        view,
        setView,
        activeItemId,
        setActiveItemId,
        activeFilters,
        setActiveFilters,
        filterModalOpen,
        setFilterModalOpen,
        page,
        setPage,
        map,
        listing,
        ...realEstateListingProps,
    };

    return (
        <RealEstateListingContext.Provider value={providerValue}>
            {children}
        </RealEstateListingContext.Provider>
    );
};

export default RealEstateListingProvider;
